import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { Globe, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import Footer from "./Footer";

export default function StaticPageLayout({ title, subtitle, children }) {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col bg-background">
      {/* Branded Header */}
      <header className="sticky top-0 z-40 bg-[#2A0A10] text-white border-b border-white/10">
        <div className="container-px h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <img src="/logo.png" alt="Hamarsathi" className="h-10 object-contain" />
          </Link>

          <div className="flex items-center gap-2">
            {/* Language Switcher */}
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setLanguage(language === "en" ? "hi" : "en")}
              className="text-white hover:bg-white/10 rounded-full flex items-center gap-1.5 px-3"
              data-testid="lang-switch-btn"
            >
              <Globe className="w-4 h-4 text-white/80" />
              <span className="text-xs font-semibold uppercase">{language === "en" ? "हिं" : "EN"}</span>
            </Button>
            <Button asChild variant="ghost" className="text-white hover:bg-white/10 rounded-full" size="sm">
              <Link to="/login">{t("nav.login")}</Link>
            </Button>
            <Button asChild className="bg-secondary hover:bg-secondary/90 text-secondary-foreground rounded-full" size="sm">
              <Link to="/register">{t("nav.register")}</Link>
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Breadcrumb / Title Bar */}
      <div className="bg-[#FAF6F7] border-b border-border/40 py-10 lg:py-12">
        <div className="container-px max-w-4xl mx-auto">
          <Link to="/" className="inline-flex items-center text-xs font-medium text-muted-foreground hover:text-primary mb-3">
            <ArrowLeft className="w-3.5 h-3.5 mr-1" />
            {language === "hi" ? "मुख्य पृष्ठ पर वापस" : "Back to Home"}
          </Link>
          <h1 className="font-heading text-3xl sm:text-4xl text-primary font-bold">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-2 text-sm sm:text-base">{subtitle}</p>}
        </div>
      </div>

      {/* Main Content Area */}
      <main className="flex-1 bg-white">
        <div className="container-px max-w-4xl mx-auto py-10 lg:py-16 prose prose-slate max-w-none">
          {children}
        </div>
      </main>

      {/* Global Footer */}
      <Footer />
    </div>
  );
}
